export default __webpack_public_path__ + "static/media/brand-main-sm.20dce046.png";